import React, { useCallback } from 'react';
import styles from './Tile.styles.scss';
import cn from 'classnames';

const Tile = ({ className, children, id, ishovered, onHover, aspectRatio }) => {
  const getAspectRatioClass = useCallback(
    (aspectRatioP) => {
      if (aspectRatioP) {
        return aspectRatioP === 1
          ? styles['aspect-ratio1']
          : styles['aspect-ratio1_4'];
      }
      return null;
    },
    [aspectRatio],
  );

  return (
    <div
      className={cn(
        styles.container,
        className,
        getAspectRatioClass(aspectRatio),
      )}
      id={id}
    >
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          ishovered,
          tileid: id,
          onHover,
        });
      })}
    </div>
  );
};

export default React.memo(Tile);
